import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { IconField } from 'primereact/iconfield';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Slider } from "primereact/slider";
import { Calendar } from 'primereact/calendar';
export default function SidebarFiltrosPrevisao(props) {
    const { 
        openFilter, 
        setOpenFilter,
        verCorCiano,
        setVerCorCiano,
        verCorMagenta,
        setVerCorMagenta,
        verCorAmarelo,
        setVerCorAmarelo,
        verCorPreta,
        setVerCorPreta,
        faixaTonerPreto,
        setFaixaTonerPreto, 
        parametroData ,
        setParametroData
          } = props;
    const [open, setOpen] = useState(false)
    


    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">Opções de Consulta</span>
        </div>
    );

 



   
    



    return (
    
            
            <Sidebar 
                onHide={() => {
                    setOpenFilter(false)
                }}
                header={customHeader} 
                visible={openFilter} 
                style={{width:'25%'}} 
                position="right" 
                className="custom-sidebar"
                {...props}
            >
            <Divider/>   
            <div className="card flex flex-wrap gap-3 p-fluid ">  
                <div className="flex-auto">
                    <label htmlFor="buttondisplay" className="font-bold block mb-2">
                        Data Inicial
                    </label>
                    <Calendar id="buttondisplay" dateFormat="yy-mm-dd" manualInput={true} value={parametroData[0]} onChange={(e) => setParametroData([e.value, parametroData[1]])} showIcon />
                </div>

                <div className="flex-auto">
                    <label htmlFor="buttondisplay" className="font-bold block mb-2">
                        Data Final
                    </label>
                    <Calendar id="buttondisplay" dateFormat="yy-mm-dd" manualInput={true}  value={parametroData[1]} onChange={(e) => setParametroData([ parametroData[0],e.value])} showIcon />
                </div>
            </div>
                <br/>
                <br/>
                <label htmlFor="email">Filtrar por níveis de Toner</label>
                <div className='pr-3 pl-3'>
                    
                    <br/>

                    <div className='flex'>
                        <span 
                            className="text-2xl mb-2 p-2 pl-3 pr-3" 
                            style={{backgroundColor : '#1E88E5', color: '#fff',cursor:'pointer', opacity : verCorCiano ? 1 : 0.2}} 
                            onClick={()=>setVerCorCiano(!verCorCiano)}>C</span>

                        <span 
                            className="text-2xl mb-2 p-2 pl-3 pr-3 ml-2" 
                            style={{backgroundColor : '#EC407A', color: '#fff', cursor:'pointer', opacity : verCorMagenta ? 1 : 0.2}}
                            onClick={()=>setVerCorMagenta(!verCorMagenta)}>M</span>
                        <span 
                            className="text-2xl mb-2 p-2 pl-3 pr-3 ml-2" 
                            style={{backgroundColor : '#FFCA28', color: '#fff',cursor:'pointer', opacity : verCorAmarelo ? 1 : 0.2}}
                            onClick={()=>setVerCorAmarelo(!verCorAmarelo)}>Y</span>
                        <span 
                            className="text-2xl mb-2 p-2 pl-3 pr-3 ml-2" 
                            style={{backgroundColor : '#000', color: '#fff',cursor:'pointer', opacity : verCorPreta ? 1 : 0.2}}
                            onClick={()=>setVerCorPreta(!verCorPreta)}>K</span>
                    </div>
                    <Slider value={faixaTonerPreto} onChange={(e) => setFaixaTonerPreto(e.value)} className="w-full mt-3" range />
                    <div className='texto-sm' style={{marginTop:'5px', fontSize: '10px',textAlign:'center'}}>Min: {faixaTonerPreto[0]} - Max: {faixaTonerPreto[1]}</div>
                </div>
              
            </Sidebar>
            
        
    );
}
